// extracted by mini-css-extract-plugin
export default {"Wrapper":"Container_Wrapper__mwvxc","Logo":"Container_Logo__ORDJN","OptOutText":"Container_OptOutText__2PsSA"};